import { render, staticRenderFns } from "./AuthFormHeader.vue?vue&type=template&id=70a742b3&"
import script from "./AuthFormHeader.vue?vue&type=script&lang=js&"
export * from "./AuthFormHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuthFormHeader.vue?vue&type=style&index=0&id=70a742b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports